<!--
 * 员工头像组件
-->
<template>
  <a-avatar
    :src="avatar"
    :size="size"
    shape="circle"
    style="backgroundColor: #00BFBF;"
  >
    {{ avatar ? "" : name }}
  </a-avatar>
</template>

<script>
export default {
  name: "LinAvatar",
  props: {
    // 头像地址
    avatar: {
      type: String,
    },
    // 头像加载错误时显示的名字
    name: {
      type: String,
      default: "",
    },
    // 组件大小
    size: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
